import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { Hash } from "components/icons/Hash";
import { Percent } from "components/icons/Percent";

export const ToggleNumbers = ({
  value,
  onValueChange,
}: {
  value: string;
  onValueChange: (v: string) => void;
}) => (
  <div className="-t-mr-3">
    <ToggleGroup
      variant="primary"
      size="xsmall"
      value={value}
      onValueChange={(value) => {
        onValueChange(value);
      }}
    >
      <ToggleGroupItem value="PERCENT">
        <Percent />
      </ToggleGroupItem>
      <ToggleGroupItem value="ABSOLUTE">
        <Hash />
      </ToggleGroupItem>
    </ToggleGroup>
  </div>
);
